import apiClient from "../../helpers/apiClient";

export const isStripeConnected = (myCompanyData) => {
    const stripeGateway = myCompanyData?.paymentGateways?.find((gateway) => gateway.type === "stripe");
    return Boolean(stripeGateway?.isConnected || myCompanyData?.defaultPaymentGateway);
};

export const connectStripeAccount = async ({ originUrl, returnPath }) => {
    const res = await apiClient.post("/api/payment/onboard-stripe-account", {
        originUrl,
        returnPath,
    });

    if (res?.data?.success && res?.data?.message === "Connected with existing stripe account") {
        return { kind: "existing" };
    }

    if (res?.data?.success && res?.data?.data?.url) {
        return { kind: "redirect", url: res.data.data.url };
    }

    throw new Error(res?.data?.message || "Failed to connect to Stripe");
};

export const applyStripeOnboardingReturn = async (query, fetchCompanyData) => {
    let isSuccess = query.get("stripe-onboard-connection-success");
    if (isSuccess === "true" && query.get("stripe-account-id")) {
        isSuccess = true;
    } else if (isSuccess === "false") {
        isSuccess = false;
    } else {
        isSuccess = null;
    }

    const res = await apiClient.post("/api/payment/update-company-onboard-success-status", {
        isSuccess,
        accountId: query.get("stripe-account-id"),
    });

    if (res?.data?.success) {
        await fetchCompanyData();
        return { success: true };
    }

    return { success: false };
};
